









































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import QRCode from 'qrcode';
import { IBankId } from '@signing-page/signing/types/bankid';
import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import LoaderCircular from '@/components/LoaderCircular.vue';
import { EButtonTypes } from '@/enums/ButtonType.ts';
import { EHintCodePending } from '@signing-page/signing/types/enums/bankid-se';

@Component({
  components: {
    Button,
    Input,
    LoaderCircular,
  },
  data: () => ({
    EButtonTypes,
  }),
})
export default class BankIdPolling extends Vue {
  @Prop() bankId: IBankId;
  qrcodeUrl = '';

  @Watch('bankId.autoStartToken')
  updateQrCodeUrl() {
    this.generateQR();
  }

  get isSigning(): boolean {
    return this.bankId.hintCode === EHintCodePending.userSign;
  }

  get autoStartToken(): string {
    return this.bankId?.autoStartToken;
  }

  handleSetSSN() {
    this.$emit('setSSN');
  }

  async generateQR() {
    try {
      this.qrcodeUrl = await QRCode.toDataURL(`bankid:///?autostarttoken=${this.autoStartToken}`);
    } catch (err) {
      this.qrcodeUrl = '';
    }
  }

  mounted() {
    this.generateQR();
  }
}
